// extracted by css-extract-rspack-plugin
export default {"root":"root-dZL8BQ","rootcenter":"rootcenter-Zr_kaY","freeBox":"freeBox-OQ6SRs","freeBoxcenter":"freeBoxcenter-JT9XYr"};